<template>
  <v-stepper v-model="stepper">
    <v-stepper-header>
      <v-stepper-step :complete="stepper > 1" step="1" color="primary">
          Выбор корпорации
      </v-stepper-step>
      <v-divider/>
      <v-stepper-step step="2" color="primary">
          Параметры
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form v-model="is_valid">
          <v-autocomplete
              v-model="shop.corporation_id"
              :items="corporations"
              item-text="name"
              item-value="id"
              label="Корпорация"
              no-data-text="Корпорация не найдена"
              :rules="[rules.required]"
          >
          </v-autocomplete>
        </v-form>

        <div class="d-flex">
          <v-spacer/>
          <v-btn color="primary"
            :disabled="!is_valid"
            @click="stepper=2"
          >
            Далее
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-content step="2">

        <div class="d-flex flex-column" style="gap: 20px">
          <General v-model="shop"/>
          <Prodelivery v-model="shop"/>
          <!-- <PaymentSettings v-model="shop.payment_agent"/> -->
          <v-card outlined>
            <v-img v-if="shop.logo_image" :src="`/media/images/${shop.logo_image}?size=lg`">
              <v-btn class="ma-2" small color="secondary" fab @click="shop.logo_image = null"><v-icon>mdi-delete</v-icon></v-btn>
            </v-img>
            <ImageCropper v-else
              @onResult="onImageData"
              :aspectRatio="1"
            />
          </v-card>
        </div>
       
        <div class="d-flex pt-4">
          <v-btn color="primary" @click="stepper=1">Назад</v-btn>
          <v-spacer/>
          <v-btn color="primary" @click="createShop">Создать</v-btn>
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapActions } from "vuex";
import mixin_rules from '@/mixins/rules_mixin.js';
import General from '../settings/General.vue';
import Prodelivery from '../settings/Prodelivery.vue';
import ImageCropper from "@/components/image-cropper/ImageCropper.vue";
// import PaymentSettings from '../settings/PaymentSettings.vue';

export default{
  props: {
    value: Object,
    corporations: Array
  },

  mixins: [mixin_rules],

  data: () => ({
    stepper: null,
    is_valid: null,
  }),

  computed:{
    shop: {
      set(v){
        this.$emit('input', v);
      },
      get(){
        return this.value;
      }
    },
  },

  methods:{
    ...mapActions('data', ['process_image']),

    createShop(){
      this.$emit('onSubmit')
    },

    async onImageData(data){
      let form = new FormData();
      form.append('image', data.image);
      form.append('crop', JSON.stringify(data.crop));
      this.loading = false;
      let res = await this.process_image(form);
      if (res) {
        this.shop.logo_image = res;
      }
      this.loading = true;
    }
  },

  components:{
    General,
    Prodelivery,
    // PaymentSettings,
    ImageCropper
  }
}
</script>